import { Empty } from 'antd'
import CantileverCard from 'components/CantileverCard'
import { useLinkedQueries } from 'features/objectViews/hooks/useLinkedObjectQueries'
import React, { FC } from 'react'
import { GeckoEntry } from 'types'

import { LinksSection } from './LinksSection'

type ObjectLinksPanelProps = {
  entry: GeckoEntry
  currentOrgId: string | undefined
  currentSiteId: string | undefined
}

export const ObjectLinksPanel: FC<ObjectLinksPanelProps> = ({
  entry,
  currentOrgId,
  currentSiteId,
}) => {
  const { parentQueries, childQueries } = useLinkedQueries(entry)

  const hasParentObjects = Object.keys(parentQueries).length > 0
  const hasChildObjects = Object.keys(childQueries).length > 0

  if (!hasParentObjects && !hasChildObjects) {
    return (
      <CantileverCard>
        <CantileverCard.Section topPadding bottomPadding>
          <Empty description='No linked objects found' />
        </CantileverCard.Section>
      </CantileverCard>
    )
  }

  return (
    <>
      {hasParentObjects && (
        <LinksSection
          title='Upward Links'
          typeToQuery={parentQueries}
          currentOrgId={currentOrgId}
          currentSiteId={currentSiteId}
          hasBottomMargin={hasChildObjects}
        />
      )}

      {hasChildObjects && (
        <LinksSection
          title='Downward Links'
          typeToQuery={childQueries}
          currentOrgId={currentOrgId}
          currentSiteId={currentSiteId}
        />
      )}
    </>
  )
}
